import Sex from './Sex';

export default Sex;
